import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ArticleCard from "./ArticleCard";

// One dominant story plus secondary stories from different sections. Reuses the existing card variants.
const TopStories = ({ lead, secondary = [], tone = "bg-white", pad = "py-12 md:py-16" }) => {
  if (!lead) return null;
  return (
    <section className={`${pad} ${tone}`} data-testid="top-stories-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <span className="editorial-overline mb-3 block">Top Stories</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-neutral-950">What <em className="italic font-normal">Matters</em> Now</h2>
          </div>
          <Link to="/category/latest" className="hidden md:flex items-center gap-1.5 text-sm font-medium text-neutral-500 hover:text-neutral-950 transition-colors" data-testid="top-stories-view-all">
            All stories <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-7" data-testid="top-stories-lead">
            <ArticleCard article={lead} className="h-full" sizes="(min-width: 1280px) 690px, (min-width: 1024px) 56vw, 100vw" />
          </div>
          <div className="lg:col-span-5 lg:border-l lg:border-neutral-100 lg:pl-10">
            <div className="-mt-6" data-testid="top-stories-secondary">
              {secondary.map((a) => (
                <ArticleCard key={a.id} article={a} variant="horizontal" className="!py-5" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopStories;
